var render = function render(_c,_vm){return (_vm.props.addressClass)?_c('img',{staticClass:"address-class store-logo",attrs:{"src":_vm.props.addressClass.iconSource,"height":"26","contain":"","alt":`logo ${_vm.props.addressClass.name}`,"title":`${_vm.props.addressClass.name}`}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }